import './Verify.scss';
import Component from './Verify.js';
export default Component;
